module.exports = __webpack_public_path__ + "static/media/IlotD_synthese_1.c449fe0a.webp";